//services/Chat.js
import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

//create a new chat user/chats
export const createChat = async (data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/chats`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get all chats user/chats
export const getChats = async (page = 1, searchTerm = '') => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/chats?page=${page}&search=${searchTerm}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


// get messages user/chats/{chatId}/messages
export const getMessages = async (chatId, page) => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/chats/${chatId}/messages?page=${page}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get single message user/chats/single-message/{messageId}
// export const getSingleMessage = async (chatId, messageId) => {
//   const token = getToken();
//   try {
//     const response = await axios.get(`${apiurl}/api/v1/user/chats/${chatId}/single-message/${messageId}`, {
//       headers: {
//         Authorization: `Bearer ${token}`,
//       },
//     });
//     return response.data;
//   } catch (error) {
//     return Promise.reject(error.response.data);
//   }
// };


// get new message count user/chats/new-message-count
export const getNewMessageCount = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/chats/new-message-count`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


// mark read user/chats/mark-read
export const markRead = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/chats/mark-read`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// /api/v1/user/share-post
export const yourNetwork = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/share-post`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
};

//sharePostWithChat /api/v1/user/share-post/with-chats/{chatId}
export const sharePostWithChat = async (chatId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/share-post/with-chats/${chatId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
};

 //sharePostWithConnection /api/v1/user/share-post/with-connections/{connectionId}
export const sharePostWithConnection = async (connectionId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/share-post/with-connections/${connectionId}`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
};


//send message user/chats/{chatId}/messages
export const sendMessage = async (chatId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/chats/${chatId}/messages`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//get chat setting user/chats/{chatId}/chat-settings
export const chatSettings = async (chatId) => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/chats/${chatId}/chat-settings`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//update chat setting user/chats/{chatId}/chat-settings
export const updateChatSettings = async (chatId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/chats/${chatId}/chat-settings`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//remove member user/chats/{chatId}/members/{userId?}
export const removeMember = async (chatId, userId) => {
  const token = getToken();
  try {
    const response = await axios.delete(`${apiurl}/api/v1/user/chats/${chatId}/members/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// makeAdmin user/chats/{chatId}/admins/{userId}
export const makeAdmin = async (chatId, userId) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/chats/${chatId}/admins/${userId}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// revokeAdmin user/chats/{chatId}/admins/{userId}
export const revokeAdmin = async (chatId, userId) => {
  const token = getToken();
  try {
    const response = await axios.delete(`${apiurl}/api/v1/user/chats/${chatId}/admins/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//exit groupr user/chats/{chatId}/members/{userId?}
export const exitGroup = async (chatId) => {
  const token = getToken();
  try {
    const response = await axios.delete(`${apiurl}/api/v1/user/chats/${chatId}/members`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};


//delete message user/chats/messages/{messageId}/delete
export const deleteMessage = async (messageId) => {
  const token = getToken();
  try {
    const response = await axios.delete(`${apiurl}/api/v1/user/chats/messages/${messageId}/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

//add reaction to message user/chats/messages/{messageId}/reactions
export const addReaction = async (messageId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/chats/messages/${messageId}/reactions`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// add member user/chats/{chatId}/members
export const addMember = async (chatId, data) => {
  const token = getToken();
  try {
    const response = await axios.post(`${apiurl}/api/v1/user/chats/${chatId}/members`, data, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// clear chat user/chats/{chatId}/delete
export const clearChat = async (chatId) => {
  const token = getToken();
  try {
    const response = await axios.delete(`${apiurl}/api/v1/user/chats/${chatId}/clear`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// Delete chat user/chats/{chatId}/delete
export const deleteChat = async (chatId) => {
  const token = getToken();
  try {
    const response = await axios.delete(`${apiurl}/api/v1/user/chats/${chatId}/delete`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};

// get unread messages count user/notifications/chats/unread-count
export const unreadMessagesCount = async () => {
  const token = getToken();
  try {
    const response = await axios.get(`${apiurl}/api/v1/user/chats/unread-message-count`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    return Promise.reject(error.response.data);
  }
};



//Message Seen 
export const messageSeen = async (chatId, messageId, type) => {
  const token = getToken();
  try {
    const response = await axios.put(`${apiurl}/api/v1/user/chats/${chatId}/messages/${messageId}/${type}`, {}, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  }
  catch (error) {
    return Promise.reject(error.response.data);
  }
};
 